import React, { useState, useEffect, useRef } from 'react';
import ComboSelector, { TipoClave } from '../UI/campos/ComboSelector.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';

const SelectFormacion = (props) => {
  const idObjeto = props.id;
  const estilo = props.estilo;
  const formacionActual = props.formacionActual;
  const [formaciones, setFormaciones] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  const fetchDataRef = useRef(fetchData);
  useEffect(() => {
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  useEffect(() => {
    // load formaciones once when component mounts or when idObjeto changes
    fetchDataRef.current('partidos/parametros/tipos_formacion', (data) => {
      // Agregar item "(desconocida)" al inicio de la lista
      const itemDesconocida = {
        codigo: null,
        descripcion: '(desconocida)',
      };
      setFormaciones([itemDesconocida, ...data]);
    });
    // depend on idObjeto only
  }, [idObjeto]);

  const onFormacionElegida = (formacion) => {
    props.onFormacionElegida(formacion);
  };

  // Determinar el valor actual a mostrar
  const getValorActual = () => {
    if (!formacionActual) {
      return '(desconocida)';
    }
    return formacionActual.descripcion || '';
  };

  return (
    <React.Fragment>
      <ComboSelector
        id={idObjeto}
        estilo={estilo}
        lista={formaciones}
        valorActual={getValorActual()}
        campoClave={TipoClave.CODIGO}
        campoDescripcion="descripcion"
        isCargando={isCargando}
        onItemElegido={onFormacionElegida}
      />
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default SelectFormacion;
